"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnChatEventType = void 0;
exports.ReturnChatEventType = {
    SystemPrompt: "SYSTEM_PROMPT",
    UserMessage: "USER_MESSAGE",
    UserInterruption: "USER_INTERRUPTION",
    AgentMessage: "AGENT_MESSAGE",
    FunctionCall: "FUNCTION_CALL",
    FunctionCallResponse: "FUNCTION_CALL_RESPONSE",
};
